var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2024-03-07
 * @brief SEI 커뮤니티 닉네임 팝업
 *
 ********************************************************************/
import { useEffect, useState } from "react";
//recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState } from "../../../recoil/assessmentState";
import { isAutoNickname, userInfoLoginState, userInfoState } from "../../../recoil/userState";
// utils
import { Trans } from "react-i18next";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import { useTrans } from "../../../utils/langs/useTrans";
export default function AutoNicknamePop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilUserInfo = useSetRecoilState(userInfoState);
    const [autoNickname, setAutoNickNname] = useRecoilState(isAutoNickname);
    const [alert, setAlert] = useRecoilState(alertState);
    //
    const [errorList, setErrorList] = useState([]);
    const [nickname, setNickname] = useState("");
    useEffect(() => {
        setNickname(userInfo.nickName);
    }, [autoNickname]);
    // 닉네임
    function handleNickname(e) {
        setErrorList(errorList.filter((err) => err.field !== "nickName"));
        let value = e.target.value;
        let noneValue = value.replace(/[ \{\}\[\]\/?.,;:|\)*~`!^\-_+┼<>@\#$%&\'\"\\\(\=₩]/g, "");
        if (value == noneValue && value.length <= 10) {
            setNickname(e.target.value);
        }
        else {
            setAlert(Object.assign(Object.assign({}, alert), { layerId: "false", divTag: value.length <= 10 ? "사용이 불가능한 단어/기능입니다." : "최대 범위를 초과혀였습니다.", callBack: () => {
                    CUTIL.jsclose_InPopup(CONST.POP_ALERT);
                } }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
    }
    //  닫기
    function Colse(id, blooean) {
        CUTIL.jsclose_Popup(id);
        if (blooean) {
            location.reload();
        }
    }
    function NickNameEdit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: "/user/nickname",
                appQuery: {
                    nickName: nickname,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum === CONST.API_200) {
                    Colse("pop-auto-nickname", false);
                    setRecoilUserInfo({
                        loginTime: data.body.loginTime,
                        userId: data.body.userId,
                        email: data.body.email,
                        userName: data.body.userName,
                        phoneNumber: data.body.phoneNumber,
                        companyName: data.body.companyName,
                        zoneName: data.body.zoneName,
                        department: data.body.department,
                        role: data.body.role,
                        language: data.body.language,
                        classificationCode: data.body.classificationCode,
                        classification: data.body.classification,
                        agreeMailReceipt: data.body.agreeMailReceipt,
                        agreeTos: data.body.agreeTos,
                        agreePersonalInfo: data.body.agreePersonalInfo,
                        agreeData: data.body.agreeData,
                        userIdPk: data.body.userIdPk,
                        isAutomatedNickName: data.body.isAutomatedNickName,
                        nickName: nickname,
                        userRank: data.body.userRank,
                        userImage: data.body.userImage,
                        loginInfo: userInfo.loginInfo,
                    });
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "닉네임이 변경되었습니다.", callBack: () => {
                            location.reload();
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList == null ? CONST.ERROR_MSG : data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-auto-nickname", className: "popup-layer js-layer hidden popup-basic pop-login w350" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: t("라벨.Community이용안내") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Colse("pop-auto-nickname", true) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsxs("div", Object.assign({ className: "popup__body find-idpw" }, { children: [_jsx(Trans, Object.assign({ i18nKey: "팝업.커뮤니티안내" }, { children: _jsxs("p", Object.assign({ className: "font-15 fontRegular txt-center mb-33 mt-20" }, { children: ["SEI Community\uB294 \uB2C9\uB124\uC784\uC73C\uB85C \uC790\uC720\uB86D\uAC8C \uC18C\uD1B5\uD558\uB294", _jsx("br", {}), "\uACF5\uAC04\uC785\uB2C8\uB2E4. \uAC1C\uC778\uC815\uBCF4 \uB178\uCD9C \uBC29\uC9C0\uB97C \uC704\uD574 \uB2C9\uB124\uC784\uC744", _jsx("br", {}), "\uD544\uC218\uB85C \uB4F1\uB85D\uD574\uC8FC\uC138\uC694."] })) })), _jsx("form", Object.assign({ action: "", method: "", name: "popfindpw", onSubmit: (e) => e.preventDefault() }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsx("li", { children: _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("div", Object.assign({ className: "radioBox mb-16" }, { children: _jsxs("label", Object.assign({ htmlFor: "rrrd1" }, { children: [_jsx("input", { type: "radio", id: "rrrd1", name: "rrrd", checked: true, readOnly: true }), t("라벨.닉네임변경")] })) })), _jsx("input", { type: "text", id: "", value: nickname, onChange: (e) => handleNickname(e) }), _jsx("p", Object.assign({ className: "input-info mt-4" }, { children: _jsxs(Trans, Object.assign({ i18nKey: "닉네임정보" }, { children: [_jsx("span", { children: "\uB2C9\uB124\uC784\uC740 \uCEE4\uBBA4\uB2C8\uD2F0 \uD65C\uB3D9\uC6A9\uC73C\uB85C\uB9CC \uC0AC\uC6A9\uB429\uB2C8\uB2E4." }), _jsx("span", { children: "\uD558\uB8E8 \uCD5C\uB300 1\uBC88\uAE4C\uC9C0 \uBCC0\uACBD \uAC00\uB2A5\uD569\uB2C8\uB2E4." }), _jsx("span", { children: "\uC911\uBCF5\uB418\uB294 \uB2C9\uB124\uC784\uC740 \uC0AC\uC6A9\uC774 \uBD88\uAC00\uD569\uB2C8\uB2E4. " }), _jsx("span", { children: "\uC774\uBAA8\uD2F0\uCF58 \uBC0F \uD2B9\uC218\uBB38\uC790 \uC0AC\uC6A9\uC774 \uBD88\uAC00\uD569\uB2C8\uB2E4." })] })) }))] })) }) })) }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "js-close bg-gray", onClick: (e) => Colse("pop-auto-nickname", true) }, { children: _jsx("span", { children: t("라벨.확인") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => NickNameEdit(e) }, { children: _jsx("span", { children: t("라벨.변경") }) }))] }))] })) }));
}
